/**
 * Landing v3 — the accent colourways (badge classes, and the hue name whose
 * `--<hue>-500-rgb` tints a hover light). Plain data, so pure modules (the
 * About team, the SEO builders) can name a hue without importing the UI.
 */

/** The icon badge's colourways (border 400 · fill 100 · glyph 600), shared
 *  by the tiles and the About page's values. */
export const BADGE_TONES = {
  amber: 'border-amber-400 bg-amber-100 text-amber-600',
  primary: 'border-primary-400 bg-primary-100 text-primary-600',
  pink: 'border-pink-400 bg-pink-100 text-pink-600',
  green: 'border-green-400 bg-green-100 text-green-600',
  // Sky, not blue: blue has no dark-theme values in the DS palette.
  sky: 'border-sky-400 bg-sky-100 text-sky-600',
  orange: 'border-orange-400 bg-orange-100 text-orange-600',
  // Share & study with friends (Figma 118:2728).
  cyan: 'border-cyan-400 bg-cyan-100 text-cyan-600',
  // 100% from your sources (Figma 118:2666): the page's own greys.
  secondary: 'border-secondary-400 bg-secondary-100 text-secondary-700',
} as const;

/** A colourway's name: its badge classes here, its `--<hue>-500-rgb` light. */
export type BadgeHue = keyof typeof BADGE_TONES;
